import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Mujeres que sienten pesadez abdominal crónica.', 'Oficinistas y comerciantes con poco tiempo para cocinar cosas raras.', 'Personas que quieren ver resultados estéticos y sentirse livianas rápido.', 'Quienes buscan una solución económica con productos locales.'];
  const isNotFor = ['Personas que buscan una dieta para bajar 10 kilos en una semana.', 'Gente que prefiere soluciones mágicas en pastillas.', 'Personas con patologías gástricas graves que requieren tratamiento médico clínico.', 'Quienes no están dispuestas a hacer pequeños cambios en su rutina.'];
  return <section className="py-20 px-4 bg-white" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-169">
          Seamos honestas...
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-170">
          {/* Para vos si */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-lightSage/50 p-8 rounded-3xl border border-sage/20" data-id="element-171">
            <h3 className="text-2xl font-serif font-bold mb-8 text-sage flex items-center gap-3" data-id="element-172">
              <CheckIcon className="w-8 h-8" data-id="element-173" />
              Este plan ES para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-174">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-175">
                  <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-176">
                    <CheckIcon className="w-4 h-4 text-sage" data-id="element-177" />
                  </div>
                  <span className="text-brown/90 text-lg" data-id="element-178">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para vos si */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-terracotta/5 p-8 rounded-3xl border border-terracotta/20" data-id="element-179">
            <h3 className="text-2xl font-serif font-bold mb-8 text-terracotta flex items-center gap-3" data-id="element-180">
              <XIcon className="w-8 h-8" data-id="element-181" />
              Este plan NO es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-182">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-183">
                  <div className="w-6 h-6 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-184">
                    <XIcon className="w-4 h-4 text-terracotta" data-id="element-185" />
                  </div>
                  <span className="text-brown/90 text-lg" data-id="element-186">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}